import { Box, Fab, Zoom } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FaChevronUp } from 'react-icons/fa'

const Upbutton = () => {
    const [showButton, setShowButton] = useState(false);

    const handleScroll = () => {
        if (window.pageYOffset > 300) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box>
            <Zoom in={showButton}>
                <Fab
                    size="medium"
                    onClick={scrollToTop}
                    sx={{
                        position: "fixed",
                        bottom: 20,
                        right: 30,
                        zIndex: 999,
                        backgroundColor: "rgb(64, 153, 247)",
                        transition: '1s',
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#000",
                        },
                    }}
                    aria-label="scroll back to top"
                >
                    <FaChevronUp />
                </Fab>
            </Zoom>
        </Box>
    )
}

export default Upbutton